import { render, staticRenderFns } from "./IQDisambiguationOption.vue?vue&type=template&id=12c3c8b0&scoped=true"
import script from "./IQDisambiguationOption.vue?vue&type=script&setup=true&lang=js"
export * from "./IQDisambiguationOption.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQDisambiguationOption.vue?vue&type=style&index=0&id=12c3c8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3c8b0",
  null
  
)

export default component.exports